// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// https://etherscan.io/address/0x4da27a545c0c5B758a6BA100e3a049001de870f5
export const STK_AAVE = '0x4da27a545c0c5B758a6BA100e3a049001de870f5';

// https://etherscan.io/address/0xa1116930326D21fB917d5A27F1E9943A9595fb47
export const STK_ABPT = '0xa1116930326D21fB917d5A27F1E9943A9595fb47';

// https://etherscan.io/address/0x209Ad99bd808221293d03827B86cC544bcA0023b
export const STK_ABPT_ORACLE = '0x209Ad99bd808221293d03827B86cC544bcA0023b';

// https://etherscan.io/address/0xecD4bd3121F9FD604ffaC631bF6d41ec12f1fafb
export const STK_ABPT_STK_AAVE_WSTETH_BPTV2_MIGRATOR = '0xecD4bd3121F9FD604ffaC631bF6d41ec12f1fafb';

// https://etherscan.io/address/0x1a88Df1cFe15Af22B3c4c783D4e6F7F9e0C1885d
export const STK_GHO = '0x1a88Df1cFe15Af22B3c4c783D4e6F7F9e0C1885d';

// https://etherscan.io/address/0x9eDA81C21C273a82BE9Bbc19B6A6182212068101
export const STK_AAVE_WSTETH_BPTV2 = '0x9eDA81C21C273a82BE9Bbc19B6A6182212068101';

// https://etherscan.io/address/0xADf86b537eF08591c2777E144322E8b0Ca7E82a7
export const STK_AAVE_WSTETH_BPTV2_ORACLE = '0xADf86b537eF08591c2777E144322E8b0Ca7E82a7';

export const CHAIN_ID = 1;
